<template>
    <b-card header="Manually Enter Service Visit"
        header-bg-variant="info"
        header-text-variant="white"
        >
        <form @keydown="form.clearError($event.target.name)">

            <b-container fluid class="text-center m-3">
                <b-row v-if="step == 1">
                    <b-col>
                        <h3 class="mb-3">Have you tried to check in/out using touch-tone telephony?</h3>
                        <b-btn variant="primary" size="lg" @click="step++">Yes</b-btn>
                        <b-btn variant="secondary" size="lg" href="/home">No</b-btn>
                    </b-col>
                </b-row>

                <b-row v-if="step == 2">
                    <b-col>
                        <h3 class="mb-3">What is the reason for not using mobile entry or touch-tone telephony?</h3>
                    
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Reason" label-for="reason">
                                    <b-select name="reason" id="reason" v-model="form.reason" @change="form.clearError('reason')">
                                        <option value="">-- Select Reason --</option>
                                        <option value="forgot">Forgot to Check-In/Out</option>
                                        <option value="no_connection">No Internet Connection</option>
                                        <option value="phone_unavailable">Landline Unavailable</option>
                                    </b-select>
                                    <input-help :form="form" field="reason" text="" />
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Comments" label-for="comments">
                                    <b-textarea id="comments"
                                                :rows="5"
                                                v-model="form.comments"
                                    />
                                    <input-help :form="form" field="comments" text="" />
                                </b-form-group>
                            </b-col>
                        </b-row>

                    <div class="d-flex justify-content-between">
                        <b-btn variant="secondary" size="lg" class="f-1" @click="step--">Go Back</b-btn>
                        <b-btn variant="primary" size="lg" @click="setReason()">Go to Manual Entry</b-btn>
                    </div>
                    </b-col>
                </b-row>
                
                <b-row v-if="step == 3">
                    <b-col>
                        <h3 class="mb-3">Which Policy Holder did you visit?</h3>

                        <b-row class="mb-5">
                            <b-col md="6" class="m-auto">
                                <b-form-group>
                                    <b-select name="client_id" id="client_id" v-model="form.client_id" @change="form.clearError('client_id')">
                                        <option value="">-- Select Policy Holder --</option>
                                        <option v-for="item in caregiver.clients" 
                                            :value="item.id" v-text="item.name"
                                            :key="item.id"
                                            @change="form.clearError('client_id')"
                                        />
                                    </b-select>
                                    <input-help :form="form" field="client_id" text="" />
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="d-flex justify-content-between">
                            <b-btn variant="secondary" size="lg" class="f-1" @click="step--">Go Back</b-btn>
                            <b-btn variant="primary" size="lg" @click="setClient()">Confirm and Continue</b-btn>
                        </div>
                    </b-col>
                </b-row>

                <b-row v-if="step == 4">
                    <b-col>
                        <h3 class="mb-3">Set the start and end time of the visit:</h3>

                        <b-row>
                            <b-col md="6">
                                <!-- start_time -->
                                <b-form-group label="Start" label-for="start_time">
                                    <date-picker
                                        v-model="form.start_date"
                                        placeholder="Start Date"
                                        class="mb-2"
                                        @input="form.clearError('start_time')"
                                    />
                                    <time-picker 
                                        v-model="form.start_time" 
                                        placeholder="HH:MM"
                                        @input="form.clearError('start_time')" 
                                    />
                                    <input-help :form="form" field="start_time" text=""></input-help>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <!-- end_time -->
                                <b-form-group label="Finish" label-for="end_time">
                                    <date-picker
                                        v-model="form.end_date"
                                        placeholder="End Date"
                                        class="mb-2"
                                        @input="form.clearError('end_time')"
                                    />
                                    <time-picker 
                                        v-model="form.end_time" 
                                        placeholder="HH:MM"
                                        @input="form.clearError('end_time')" 
                                    />
                                    <input-help :form="form" field="end_time" text=""></input-help>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div class="d-flex justify-content-between">
                            <b-btn variant="secondary" size="lg" class="f-1" @click="step--">Go Back</b-btn>
                            <b-btn variant="primary" size="lg" @click="setDates()">Confirm and Continue</b-btn>
                        </div>
                    </b-col>
                </b-row>

                <b-row v-if="step == 5">
                    <b-col>
                        <h3 class="mb-3">Select the services performed during the visit:</h3>
                    
                        <b-row class="mb-2" v-for="activity in activities" :key="activity.id">
                            <b-col cols="6">{{ activity.name }}</b-col>
                            <b-col cols="6">
                                <b-form-select name="test" v-model="form.activities[activity.id]" @change="form.clearError('activities')">
                                    <option value="">---</option>

                                    <option v-for="option in activity.responses" :key="option.id" :value="option.name" v-text="option.name" />
                                </b-form-select>
                            </b-col>
                        </b-row>
                        
                        <div class="text-center">
                            <input-help :form="form" field="activities" text=""></input-help>
                        </div>

                        <div class="d-flex justify-content-between">
                            <b-btn variant="secondary" size="lg" class="f-1" @click="step--">Go Back</b-btn>
                            <b-btn variant="primary" size="lg" @click="submit()">Submit Entry</b-btn>
                        </div>
                    </b-col>
                </b-row>

                <b-row v-if="step > 5">
                    <b-col>
                        <h3>Your visit has been successfully recorded.</h3>
                    </b-col>
                </b-row>
            </b-container>
        </form>
    </b-card>
</template>

<script>
    export default {
        props: {
            'caregiver': {},
            'activities': Array,
        },

        data() {
            return {
                step: 1,
                form: new Form({
                    client_id: '',
                    reason: '',
                    comments: '',
                    start_date: '',
                    start_time: '',
                    end_date: '',
                    end_time: '',
                    activities: [],
                    checked_in_time: '',
                    checked_out_time: '',
                }),
            }
        },

        methods: {
            setReason() {
                if (this.form.reason.trim().length == 0) {
                    return this.form.addError('reason', 'Reason is required.');
                }

                if (this.form.comments.trim().length == 0) {
                    return this.form.addError('comments', 'Comments are required.');
                }

                this.step++;
            },

            setClient() {
                if (this.form.client_id.length == 0) {
                    return this.form.addError('client_id', 'Policy Holder is required.');
                }

                this.step++;
            },

            setDates() {
                if (!this.validDate(this.form.start_date)) {
                    return this.form.addError('start_time', 'Start date is required.');
                }
                
                if (!this.validDate(this.form.start_time)) {
                    return this.form.addError('start_time', 'Start time is required.');
                }
                
                if (!this.validDate(this.form.end_date)) {
                    return this.form.addError('end_time', 'End date is required.');
                }

                if (!this.validDate(this.form.end_time)) {
                    return this.form.addError('end_time', 'End time is required.');
                }

                // convert date and start/end time to proper check in/out datetime
                let start = moment(this.form.start_date + ' ' + this.form.start_time, 'MM/DD/YYYY HH:mm');
                let end = moment(this.form.end_date + ' ' + this.form.end_time, 'MM/DD/YYYY HH:mm');

                if (end.isBefore(start)) {
                    // overlaps to the next day
                    return this.form.addError('end_time', 'End time cannot be before the start time.');
                }

                let now = moment();

                // make sure dates are not in the future
                if (now.isBefore(start)) {
                    return this.form.addError('start_time', 'Date cannot be in the future.');
                }
                if (now.isBefore(end)) {
                    return this.form.addError('end_time', 'Date cannot be in the future.');
                }

                // make sure dates are during the current Mon-Sun period
                let periodStart = moment().startOf('isoWeek');
                let periodEnd = moment().endOf('isoWeek');

                // if it's before 7:59am, dates can be between the previous period as well
                let monday8am = moment().startOf('isoWeek').add(8, 'hours');
                if (now.isBefore(monday8am) < 0) {
                    periodStart = moment().subtract(1, 'weeks').startOf('isoWeek');
                }

                if (start.isBefore(periodStart) || start.isAfter(periodEnd)) {
                    console.log(start);
                    console.log(periodStart);
                    return this.form.addError('start_time', 'Visit must be during the current week.');
                }
                if (end.isBefore(periodStart) || end.isAfter(periodEnd)) {
                    return this.form.addError('end_time', 'Visit must be during the current week.');
                }

                // make sure start / end time aren't the same
                if (end.isSame(start, 'minutes')) {
                    return this.form.addError('end_time', 'Visit cannot start and end at the same time.');
                }
                
                // make sure duration doesn't last longer than X hours
                if (end.diff(start, 'hours', true) > 24) {
                    return this.form.addError('end_time', 'Visit cannot exceed 24 hours.');
                }

                this.form.checked_in_time = start.utc().format('YYYY-MM-DD HH:mm:ss');
                this.form.checked_out_time = end.utc().format('YYYY-MM-DD HH:mm:ss');

                this.step++;
            },

            submit() {
                if (this.form.activities.length == 0) {
                    this.form.addError('activities', 'You must select at least one activity.');
                    return;
                }
 
                this.form.post(`/manual-shift`)
                    .then( ({ data }) => {
                        this.step++;
                    })
                    .catch(e => {
                    });
            },

            validDate(val) {
                if (!val || val == '') return false;
                return moment(val, 'mm/dd/yyyy').isValid();
            },
        },

        mounted() {
        },
    }
</script>
